import { authenticatedApiFetch } from "../../common/helpers";
import { message } from "antd";
import { getTranslate } from "react-localize-redux";
import { onSuccess, onError } from "actionware";
import { getMessageID } from "../../common/helpers";

export async function fetchProfileData() {
  return await authenticatedApiFetch(`user`, "GET");
}

export async function saveGeneralInfo(data) {
  //await authenticatedApiFetch(`profile`, 'POST', data);
  return data;
}

export async function savePersonalInfo(data) {
  //await authenticatedApiFetch(`profile`, 'POST', data);
  return data;
}

export async function saveBankInfo(data) {
  //await authenticatedApiFetch(`profile`, 'POST', data);
  return data;
}

export async function savePassword(data) {
  return await authenticatedApiFetch(
    `changeLoginPassword`,
    "PUT",
    data
  );
}

export async function fetchLenderProfile() {
  const response = await authenticatedApiFetch(
    `lender/profile-details`,
    "GET",
    { msg_id: getMessageID() }
  );
  return response.data;
}

// Side effects
// ------------------------------

const successMessage = ({ store: { getState } }) => {
  const { localize } = getState();
  const translate = getTranslate(localize);
  message.success(translate("generic.successfulSave"));
};

const errorMessage = ({ store: { getState } }) => {
  const { profile } = getState();
  message.error(profile.errorMessage);
};

onSuccess(saveGeneralInfo, successMessage);
onSuccess(savePersonalInfo, successMessage);
onSuccess(saveBankInfo, successMessage);
onSuccess(savePassword, successMessage);
onError(savePassword, errorMessage);
